import { makeRoute } from './makeRoute';

/*
 * Relative inside the blog (NEXT_PUBLIC_APP_NAME=blog), absolute everywhere
 * else. The shared site header links to these from both apps, and a relative
 * href is what lets the blog's own nav stay a client-side navigation.
 */
export const home = makeRoute(() => `/`, 'blog');

export const post = makeRoute((args: { slug: string }) => `/blog/${args.slug}`, 'blog');

export const author = makeRoute((args: { slug: string }) => `/author/${args.slug}`, 'blog');

export const ghostAdmin = makeRoute(() => `/ghost`, 'blog');

export const rss = makeRoute(() => `/rss.xml`, 'blog');

export const sitemap = makeRoute(() => `/sitemap.xml`, 'blog');

/*
 * Every blog section is a Ghost tag page. The four sections have builders below;
 * the three knowledge base categories (kb-basics, kb-tax, kb-pov) go through
 * tag({ slug }). The old /case-studies and /release-notes paths redirect to
 * their tag pages in apps/blog/next.config.mjs.
 */
export const tag = makeRoute((args: { slug: string }) => `/tag/${args.slug}`, 'blog');
export const knowledgeBase = makeRoute(() => `/tag/knowledge-base`, 'blog');
export const caseStudies = makeRoute(() => `/tag/case-studies`, 'blog');
export const announcements = makeRoute(() => `/tag/announcements`, 'blog');
export const releaseNotes = makeRoute(() => `/tag/release-notes`, 'blog');
